import React from "react";
import Routes from "./Routes";
import ReactDOM from "react-dom";

ReactDOM.render(<Routes />, document.getElementById("root"));
